import { useContext } from "react";
import { AppContext } from "./AppContextProvider";

const useAppContextProvider = () => {
    return useContext(AppContext);
};

export default useAppContextProvider;
